import { combineReducers } from "redux";
import call from "./call";
import error from "./error";
import room from "./room";

const allReducers = combineReducers({
  call,
  error,
  room,
});

const rootReducer = (state, action) => {
  return allReducers(state, action);
};

export default rootReducer;
